import { config, library } from '@fortawesome/fontawesome-svg-core';
import { fasr } from '@fortawesome/sharp-regular-svg-icons';
import { fass } from '@fortawesome/sharp-solid-svg-icons';

/**
 * Registers Font Awesome Sharp icon packs and configures the icon library.
 *
 * - Adds the Sharp Regular (`fasr`) and Sharp Solid (`fass`) icon packs to the Font Awesome library.
 * - Disables automatic addition of Font Awesome CSS to the document.
 * - Sets the default icon family to 'sharp'.
 *
 * This function should be called during application initialization to ensure
 * that the required icon packs and configuration are available globally.
 */
export const registerIcons = () => {
  library.add(fasr);
  library.add(fass);

  config.autoAddCss = false;
  config.familyDefault = 'sharp';
};
